import React, { useEffect, useState } from "react";
import FormleftNev from "../../components/common/FormleftNev";
import FormnavBar from "../../components/common/wizard_navbar";
import Lang from "../../lang";
import TlkTable from "../../components/tlelrik/table/tlkTable";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { Switch } from "@progress/kendo-react-inputs";
import { Tooltip } from "antd";
import { Button } from "@progress/kendo-react-buttons";
import { Input } from "@progress/kendo-react-inputs";
import queryString from "query-string";
import services from "../../services";
import { toast } from "react-toastify";
import $ from "jquery";
import jsPDF from "jspdf";
import lang from "../../lang";
import LabelTabel from "./LabelTable.jsx";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { PanelBar} from "@progress/kendo-react-layout";
import { MultiSelect } from '@progress/kendo-react-dropdowns';
import Swal from "sweetalert2";

var moment = require("moment");
const defaultItem = {
    text: "Selecione...",
  };
const dateFormat = "DD-MM-YYYY";
const dateShowFormat = "dd/MM/yyyy";
const fullDateFormat = "DD-MM-YYYY HH:mm:ss";
var sizes = []
let imageObj =
    "data:image/png;base64,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";

const InputFieldsAll = {
    Charatiristicas_do_Rotulo: [],
    Imagens: [],
    Processa_mento: [],
};
let listdefaultRequest = {
    Filters: null,
    SortBy: "",
    IsSortTypeDESC: true,
    IsPagination: true,
    Page: 1,
    PageSize: 20,
    idEntidade: null
};
var textoTipo;
var disableSubmit = false;
var arrayTeste = [];
let tablesjson = {
    
    RotulosNDPHistoricoRotulos: {
        columnkeyMap: {
            correlativa: "Número de Rotulagem",
            estado: "Estado",
            data: "Data",
            fundamentacao: "Fundamentação",
            utilizador: "Utilizador"
        },
        actionbuttons: {AutoButton: "Detalhes" , PdfToo: "pdf" , Desselagem:"Desselagem"},// Redirect: "Emitir Fatura",
        // listApilink: "/Rotulos/GetCorrelativas",
        // requestMethod: "get",
        notAction: false,
        totalPageHeading: "Lista de fiscalizações pendentes ",
        Filters: {
       
        },
        groupfield: [],
    },
    RotulosNDResumoRegisto: {
        columnkeyMap: {
            numeroRegisto: "Nº de Certificação",
            produto: "Produto",
            cor: "Cor",
            tav: "TAV (%)",
            anoProduto: "Ano",
            mencaoFacultativa: "Menção Facultativa",
            // mencaoObrigatoria: "Menção Obrigatória",
            mencaoQualitativa: "Menção Qualitativa",
            //nivelQualitativo: "Nível Qualitativo",
            madeira: "Madeira",
            grauDocura: "Grau Doçura",
            acidez: "Acidez (%)",
            volumeInicial: "Vol. Inicial (L)"
        },
        actionbuttons: {AutoButton: "Detalhes" , PdfToo: "pdf" , Desselagem:"Desselagem"},// Redirect: "Emitir Fatura",
        // listApilink: "/ContaCorrente/ViewRegistoProduto",
        // requestMethod: "get",
        notAction: false,
        totalPageHeading: "Lista de fiscalizações pendentes ",
        Filters: {
       
        },
        groupfield: [],
    }
    
}


var sim = "Sim";
var nao = "Não";

const frase = {};
const columnkeyMap = {
    title: Lang.langCheck.langRequest("Title"),
    entity: Lang.langCheck.langRequest("Entity"),
    status: Lang.langCheck.langRequest("Status"),
    observation: Lang.langCheck.langRequest("Observation"),
    attendance: Lang.langCheck.langRequest("Attendance")
}

class RotulosNDProcesso extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            filteredSizes: null,
            Responsaveis: [],
            selectedSizes: [],
            dadosGuardados: "",
            finalDataArray: [],
            show: false,
            isRemarkSet: false,
            mandatoryMissing: false,
            headName: "N de processo",
            Ultimaobservacao: "",
            sendData: {
                processomento: {
                    pmentos: [],
                },
                processo: {
                    bib: false,
                    seloIncorporado: false,
                    logo: false,
                    macrapropria: false,
                },
                Dataatual: new Date(),
                
                aprovodo: true,
            },
            // readOnly : false,
            readOnly: true,
            parsed: {},
            telkikTable: "",
            entityGrid: "",
            tituloList: [],
            processoTelkikTable: "",
            resData: {},
            TipoReprov:{},
            registoData: {},
            registoDataProcessamento: {},
            imagens: [],
            arrayTeste:[],
            filterData: [
                {
                    "Nº Registo": "a",
                    Produto: "a",
                    Cor: "a",
                    Álcool: "a",
                    Tipo: "a",
                    Ano: "a",
                    Doçura: "a",
                    "Acidez (%)": "a",
                    "Saldo Incial (Lts)": "a",
                    Madeira: "a",
                    "Velor energetico": "Velor energetico",
                    Carbohydratos: "Carbohydratos",
                    Proteinas: "Proteinas",
                    "Fibra Elimentor": "Fibra Elimentor",
                    Sodio: "Sodio",
                    "Rotulus aprovados": "xxxxx",
                },
            ],
            nullProcess: true,
        };
    }

    columnlist = Object.keys(columnkeyMap).map(function (key) {
        return { field: columnkeyMap[key], columnMenuType: 'checkbox' }
    }); 

    handleSave = async () => {
        // let numeroAvalcao;
        // if (this.state.resData.evaluationStatus === "pending") {
        //     numeroAvalcao = 0;
        // } else if (
        //     this.state.resData.evaluationStatus === "under_review1" ||
        //     this.state.resData.evaluationStatus === "review1_pending_2"
        // ) {
        //     numeroAvalcao = 1;
        // } else {
        //     numeroAvalcao = 2;
        // }
        // // if (this.state.sendData.Ultimaobservacao === "") {
        // //     this.setState({
        // //         mandatoryMissing: true,
        // //     });
        // //     toast.error("Campos de entrada obrigatórios ausentes!");
        // //     return;
        // // }
        // if (!this.state.isRemarkSet && this.state.nullProcess) {
        //     this.setState({
        //         mandatoryMissing: true,
        //     });
        //     toast.error("Existem campos por preencher");
        //     return;
        // }
        let parsed = queryString.parse(window.location.search);
        let sendCodEstado;
        if (this.state.sendData.aprovodo){
            sendCodEstado = 2;
        }
        else{
            sendCodEstado = 6;
        }

            let data = {
                idEntidade: parsed.idEntidade,
                IDRotulo: parsed.id,
                CodEstado: sendCodEstado,
                LoggedUser: window.localStorage.getItem('username'),
                Observacoes: $("#Ultimaobservacao").val()
            };

        let res = await services.apiCall.requestApi(
            "/Rotulos/AprovarRotulosBackOffice",
            data,
            "post"
        );
        if (res) {
            this.redirectScreen();
        }
    };

    redirectScreen = () => {
        let paramoption = {};
        let url = "";
        if (this.state.parsed.from === "rotulos") {
            url = "/rotulos";
            if (this.state.parsed.evaluator == 1) {
                paramoption = {
                    name: "1ª avaliação",
                    url: "/rotulos",
                    tableName: "RotulosOneAvalicao",
                };
            } else if (this.state.parsed.evaluator == 2) {
                paramoption = {
                    name: "2ª avaliação",
                    url: "/rotulos",
                    tableName: "RotulosTwoAvalicao",
                };
            } else {
                paramoption = {
                    name: "Pendentes",
                    url: "/rotulos",
                    tableName: "RotulosPendentes",
                };
            }
        } else if (this.state.parsed.from === "minhas_avaliações") {
            url = "/minhas_avaliações";
            paramoption = {
                name: "Minhas avaliações",
                url: "/minhas_avaliações",
                tableName: "minhas_avaliações",
            };
        }
        this.props.history.push({
            pathname: url || "/rotulos",
            state: { paramoption },
        });
    };

    handlePopUpsubmit = (data) => {
        let { finalDataArray } = this.state;
        // finalDataArray=[...finalDataArray,data];
        finalDataArray = [
            ...finalDataArray,
            { discritivo: data.discritivo, titulo: data.id },
        ];
        let tableRowData = { ...data };
        let newData = { ...this.state.sendData };
        newData["processomento"] = { ...newData.processomento };
        newData["processomento"]["pmentos"] = [
            ...newData.processomento.pmentos,
            tableRowData,
        ];
        this.setState(
            {
                sendData: newData,
                show: false,
                finalDataArray,
            },
            () =>
                this.createTabel(
                    "processomento",
                    this.state.sendData.processomento.pmentos
                )
        );
    };

    createPDF = (type) => {
        var doc = new jsPDF("p", "pt", "a4");
        if (type === "Outros Formatos") {
            this.state.resData.imagens &&
                this.state.resData.imagens.map((imageData, i) => {
                    doc.addImage(imageObj, "PNG", 150, 100, 350, 150);
                    if (i < this.state.resData.imagens.length - 1) {
                        doc.addPage();
                    }
                });
            doc.save(type);
        } else if (type === "document") {
            let image =
                this.state.resData &&
                this.state.resData.características_do_rotulo &&
                this.state.resData.características_do_rotulo
                    .documentodecedencia; // use this code but it break so commented for now
            // let image = imageObj
            // doc.addImage(image, 'PNG', 150, 100, 350, 150);
            console.log("image", image);
            var a = document.createElement("a"); //Create <a>
            a.href = "data:image/png;base64," + image; //Image Base64 Goes here
            a.download = "Image.png"; //File name Here
            a.click();
        }
    };

    handleSubmit = async () => {
        // if (
        //     !this.state.sendData.aprovodo &&
        //     Number(this.state.parsed.evaluator) === 2
        // ) {
        //     this.returntoFirst(this.state.sendData.Ultimaobservacao);
        //     return;
        //     // this.history.push()
        // }
        // // if (!this.state.isRemarkSet && this.state.nullProcess) {
        // //     this.setState({
        // //         mandatoryMissing: true,
        // //     });
        // //     toast.error("Campos de entrada obrigatórios ausentes!");
        // //     return;
        // // }
        // let numeroAvalcao;
        // if (this.state.resData.evaluationStatus === "pending") {
        //     numeroAvalcao = 0;
        // } else if (
        //     this.state.resData.evaluationStatus === "under_review1" ||
        //     this.state.resData.evaluationStatus === "review1_pending_2"
        // ) {
        //     numeroAvalcao = 1;
        // } else {
        //     numeroAvalcao = 2;
        // }
        // console.log("value", numeroAvalcao);
        // // if (
        // //     this.state.sendData.Dataatual === "" ||
        // //     this.state.sendData.Ultimaobservacao === ""
        // // ) {
        // //     toast.error("Campos de entrada obrigatórios ausentes!");
        // //     return;
        // // }
        // if (!this.state.isRemarkSet && this.state.nullProcess) {
        //     this.setState({
        //         mandatoryMissing: true,
        //     });
        //     toast.error("Existem campos por preencher");
        //     return;
        // }
        // if (this.state.sendData.Dataatual === "") {
        //     toast.error("Existem campos por preencher");
        //     return;
        // } else {
        let parsed = queryString.parse(window.location.search);
        let sendCodEstado;
        if (this.state.sendData.aprovodo){
            sendCodEstado = 2;
        }
        else{
            sendCodEstado = 6;
        }

            let data = {
                idEntidade: parsed.idEntidade,
                IDRotulo: parsed.id,
                CodEstado: sendCodEstado,
                LoggedUser: window.localStorage.getItem('username'),
                Observacoes: $("#Ultimaobservacao").val()
            };

            console.log("SEND DATA: ", this.state.sendData);

            let res = await services.apiCall.requestApi(
                "/Rotulos/AprovarRotulos",
                data,
                "post"
            );
            if (res) {
                this.redirectScreen();
            }
        //}
    };

    ActionPerform = () => { };

    
    
    isRemarkSet = () => {
        this.setState({
            isRemarkSet: true,
        });
    };

    componentDidMount() {
        $(window).scrollTop(0);
        //this.getTituloList();
        let parsed = queryString.parse(window.location.search);
        console.log("parsed in mount", parsed);
        console.log("PROPS: ", this.props);
       
        this.setState(
            {
                parsed,
                readOnly: parsed.evaluator ? false : true,
                estado: parsed.estado,
                resData: {},
            },
            () => {
                if (parsed.id) {
                    this.getEvaluationData(parsed.id);
                }
            }
        );

        this.getUserList();
    }

    getUserList = async () => {
        // console.log("daaaaatttaaa",data)
        var data = {}
        let _user = await services.apiCall.requestApi(
            "Rotulos/UsersSIVDP",
            data,
            "get"
        );

        console.log("useeeeeee", _user);

        this.setState({ Responsaveis: _user });

        if (_user != null) {
           
            var strHTML = "<option value='0' selected>Selecione...</option>";
            for (var i = 0; i < _user.length; i++) {
                strHTML = strHTML + "<option value='" + _user[i].id + "'>" + _user[i].fullName + "</option>";
            }
            $("#RespAnalise").html(strHTML);

           
        } else {

        }

    }

    

    componentDidUpdate(preprops) {
        (async () => {
            const data1 = {};
            const resTipoReprovacao = await services.apiCall.requestApi(
                "/Rotulos/GetTipoReprovacao",
                data1,
                "get"
            );
            
            // Array para armazenar os novos tamanhos
            const arraycenas = [];
            sizes = []
            for (let index = 0; index < resTipoReprovacao.length; index++) {
                const idTipoReprovacao = resTipoReprovacao[index].idTipoReprovacao;
                const descricao = resTipoReprovacao[index].descricao;
                const codTipoReprovacao = resTipoReprovacao[index].codTipoReprovacao;
                const textoDescricao = `${codTipoReprovacao} - ${descricao}`;
                const Titulo = resTipoReprovacao[index].titulo;
        
                // Adiciona cada novo item ao array
                arraycenas.push({ value: idTipoReprovacao, text: textoDescricao });

                sizes.push({value : descricao , text:Titulo})
            }
        
            // Atualiza o estado com todos os itens de uma vez
           
           
        })();
     }

    getTableDate = (type, data) => {
        //console.log("data Registo: ", data)
        
        if (type === "Processamento") {
            Object.keys(tablesjson.RotulosNDResumoRegisto.columnkeyMap).map((key) => {
                data.map((el) => {
                    if (key === "numeroRegisto") {
                        el[tablesjson.RotulosNDResumoRegisto.columnkeyMap[key]] = el.numeroRegisto;
                    } 
                    else if (key === "cor") {
                        el[tablesjson.RotulosNDResumoRegisto.columnkeyMap[key]] = el.cor;
                    } 
                    else if (key === "produto") {
                        el[tablesjson.RotulosNDResumoRegisto.columnkeyMap[key]] = el.produto;
                    } 
                    else if (key === "tav") {
                        el[tablesjson.RotulosNDResumoRegisto.columnkeyMap[key]] = el.tav;
                    } 
                    else if (key === "anoProduto") {
                        el[tablesjson.RotulosNDResumoRegisto.columnkeyMap[key]] = el.anoProduto;
                    } 
                    else if (key === "mencaoFacultativa") {
                        el[tablesjson.RotulosNDResumoRegisto.columnkeyMap[key]] = el.mencaoFacultativa;
                    } 
                    // else if (key === "mencaoObrigatoria") {
                    //     el[tablesjson.RotulosNDResumoRegisto.columnkeyMap[key]] = el.mencaoObrigatoria;
                    // } 
                    else if (key === "mencaoQualitativa") {
                        el[tablesjson.RotulosNDResumoRegisto.columnkeyMap[key]] = el.mencaoQualitativa;
                    } 
                    else if (key === "madeira") {
                        el[tablesjson.RotulosNDResumoRegisto.columnkeyMap[key]] = el.madeira;
                    }
                    else if (key === "volumeInicial") {
                        el[tablesjson.RotulosNDResumoRegisto.columnkeyMap[key]] = el.volumeInicial;
                    }
                    else if (key === "grauDocura") {
                        el[tablesjson.RotulosNDResumoRegisto.columnkeyMap[key]] = el.grauDocura;
                    }
                    else if (key === "acidez") {
                        el[tablesjson.RotulosNDResumoRegisto.columnkeyMap[key]] = el.acidez;
                    }
                  
                });
            });
        }
    };
    
    getTableDateProcessamento = (type, data) => {
        //console.log("data Processamento: ", data)
        if (type === "Processamento") {
            var res= {}
            if(data.length > 0){
                data = data[0]
            }
            
            Object.keys(tablesjson.RotulosNDPHistoricoRotulos.columnkeyMap).map((key) => {
                data.map((el) => {
                for (let index = 0; index < data.length; index++) {
                    if (key === "estado") {
                        el[tablesjson.RotulosNDPHistoricoRotulos.columnkeyMap[key]] = el.estado
                        // for (let index = 0; index < el.length; index++) {
                            
                        //     if(el[index].idEstado == 2){
                        //         el[tablesjson.RotulosNDPHistoricoRotulos.columnkeyMap[key]] = "Aprovado";
                        //     } 
                        //     if(el[index].idEstado == 4){
                        //         el[tablesjson.RotulosNDPHistoricoRotulos.columnkeyMap[key]] = "Pendente";
                        //     }
                        //     if(el[index].idEstado == 5){
                        //         el[tablesjson.RotulosNDPHistoricoRotulos.columnkeyMap[key]] = "Recurso";
                        //     }
                        //     if(el[index].idEstado == 6){
                        //         el[tablesjson.RotulosNDPHistoricoRotulos.columnkeyMap[key]] = "Reprovado";
                        //     }   
                        //     if(el[index].idEstado == 7){
                        //         el[tablesjson.RotulosNDPHistoricoRotulos.columnkeyMap[key]] = "Anulado";
                        //     } 
                        // }                 
                    }else if (key === "data") {
                        el[tablesjson.RotulosNDPHistoricoRotulos.columnkeyMap[key]] = el.data
                        ? moment(el.data).format(
                            fullDateFormat) : "nd";
                    } 
                    else if (key === "fundamentacao") {
                        el[tablesjson.RotulosNDPHistoricoRotulos.columnkeyMap[key]] = el.fundamentacao;
                    } 
                    else if (key === "correlativa") {
                        el[tablesjson.RotulosNDPHistoricoRotulos.columnkeyMap[key]] = el.correlativa;   
                    } 
                    else if (key === "utilizador") {
                        el[tablesjson.RotulosNDPHistoricoRotulos.columnkeyMap[key]] = el.utilizador;
                    }
                   
                }
                
            });
            
        });
      
        }
    };

    getEvaluationData = async (id) => { 
        arrayTeste = [];
           
        let data = {
            idRotulo: id,
        };
        let res = await services.apiCall.requestApi(
            "/Rotulos/GetRotuloDetalheBackOffice",
            data,
            "get"
        );

        if (Object.keys(res).length > 0) {
            //console.log("800 response ", res);
            var indexaMais = 0

            $('#id-rotulo-label-id').html('Rótulo ' + res.idRotulo);

            this.setState({ idMarcaLocalizacao: res.idMarcaLocalizacao, });
            var htmlAnexoMarca = []
            for (let index = 0; index < res.anexos.length; index++) {
                if(res.anexos[index].anexoPrincipal == true){
                var imagem = res.anexos[index].anexo;
                var nome = res.anexos[index].nome;
                var url = res.anexos[index].nome.indexOf('.png') > -1 ? "data:image/png;base64,"+ imagem : "data:application/pdf;base64,"+ imagem;
                
                $("#anexosBox").append('<button style="text-align: left;background-color: transparent;border: none;font-weight: 600;" id="'+url+'" class="anexoimage ' +nome.replaceAll(' ', '')+'">'+nome+'</button>')
                indexaMais =+ 1

                $(".anexoimage").off("click").on("click" , function(e){
                    var pontos = e.currentTarget.classList[1].split(".");

                    if(e.currentTarget.classList[1].split(".")[pontos.length - 1] == "pdf" || e.currentTarget.classList[1].split(".")[pontos.length - 1] == "PDF"){
                        var data = e.currentTarget.id.split("data:application/pdf;base64,")[1]
                        var byteCharacters = atob(data);
                        var byteNumbers = new Array(byteCharacters.length);
                        for (var i = 0; i < byteCharacters.length; i++) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                        }
                        var byteArray = new Uint8Array(byteNumbers);
                        var file = new Blob([byteArray], { type: 'application/pdf;base64' });
                        var fileURL = URL.createObjectURL(file);
                        window.open(fileURL);
                    }else{
                        var urlBase =  e.currentTarget.id
                        var image = new Image();
                        image.src = urlBase;
                        var w = window.open("");
                        w.document.write(image.outerHTML);
                    }
                })
                }
            }
            for (let index = 0; index < res.anexos.length; index++) {
                if(res.anexos[index].anexoPrincipal == false){
                    var imagem = res.anexos[index].anexo;
                    var nome = res.anexos[index].nome;
                    var url = res.anexos[index].nome.indexOf('.png') > -1 ? "data:image/png;base64,"+ imagem : "data:application/pdf;base64,"+ imagem;
                    
                    $("#anexosBox1").append('<button style="text-align: left;background-color: transparent;border: none;font-weight: 600;" id="'+url+'" class="anexoimage ' +nome.replaceAll(' ', '')+'">'+nome+'</button>')
                    indexaMais =+ 1

                    $(".anexoimage").off("click").on("click" , function(e){
                        var pontos = e.currentTarget.classList[1].split(".");

                        if(e.currentTarget.classList[1].split(".")[pontos.length - 1] == "pdf" || e.currentTarget.classList[1].split(".")[pontos.length - 1] == "PDF"){
                            var data = e.currentTarget.id.split("data:application/pdf;base64,")[1]
                            var byteCharacters = atob(data);
                            var byteNumbers = new Array(byteCharacters.length);
                            for (var i = 0; i < byteCharacters.length; i++) {
                            byteNumbers[i] = byteCharacters.charCodeAt(i);
                            }
                            var byteArray = new Uint8Array(byteNumbers);
                            var file = new Blob([byteArray], { type: 'application/pdf;base64' });
                            var fileURL = URL.createObjectURL(file);
                            window.open(fileURL);
                        }else{
                            var urlBase =  e.currentTarget.id
                            var image = new Image();
                            image.src = urlBase;
                            var w = window.open("");
                            w.document.write(image.outerHTML);
                        }
                    })
                }
            }
        }

        let resImagens = await services.apiCall.requestApi(
            "/Rotulos/GetImagens",
            data,
            "get"
        );
        let parsed2 = queryString.parse(window.location.search);
        console.log("Imagens: ", resImagens);
        let dataRegisto = {
            numeroRegisto: +res.numeroRegisto,
            IDRegistoProdutoEncrypt: parsed2.idRegistoProduto, 
        };
        let resRegisto = await services.apiCall.requestApi(
            "/ContaCorrente/ViewRegistoProduto",
            dataRegisto,
            "get"
        );
        let dataRegisto1 = {idrotulo : +res.idRotulo}
        let arrayProcesso = [];
        
        let historico = await services.apiCall.requestApi(
            "/Rotulos/GetRotuloHistorico",
            dataRegisto1,
            "get"
        );
        //console.log("response historico", historico);
            if(historico != undefined){
                if(historico.length > 0){
                    arrayProcesso.push(historico);
                }
            }
        

        console.log("response", res);
        console.log("historico", historico);
        console.log("Utilizador", historico.find(c=> c.estado == "Reprovado"));
        //console.log("response data registo", resRegisto);
        
        arrayTeste.push(resRegisto);
        

        if (res) {
            
            let resData = res;
            var estadoHistorico = historico.find(c=> c.estado == "Reprovado");
            if(resData.idResponsavelAnalise){
                $("#RespAnalise option[value='" + resData.idResponsavelAnalise + "']").attr("selected", "selected");
            }
            if(res.estado != undefined && res.estado == "Recurso" && estadoHistorico.utilizador == localStorage.username){
                //$('#id-button-submit-exit').remove();
                disableSubmit = false;
            }
            if (res.estado != undefined && res.estado == "Aprovado"){
                $('#id-button-submit-exit').remove();
            }
            if (res.estado != undefined && res.estado == "Reprovado" && estadoHistorico.utilizador == localStorage.username){
                $('#id-button-submit-exit').remove();
            }


            this.setState(
                {
                    resData,
                    registoData: arrayTeste,
                    registoDataProcessamento: arrayProcesso,
                    imagens: resImagens
                },
                () => {
                    this.getTableDate(
                        "Processamento",
                        this.state.registoData
                    );
                    this.getTableDateProcessamento(
                        "Processamento",
                        this.state.registoDataProcessamento
                    )
                    this.createTableRegisto(
                        "Processamento",
                        this.state.registoData
                    );
                    this.createTableProcessameno(
                        "Processamento",
                        this.state.registoDataProcessamento
                    )
                }
            );
        }
    };

    createTableProcessameno = async (type, data) => {

        const columnlistProcessamento = Object.keys(tablesjson.RotulosNDPHistoricoRotulos.columnkeyMap).map(function (key) {
            return { field: tablesjson.RotulosNDPHistoricoRotulos.columnkeyMap[key], columnMenuType: "checkbox" };
        });
        if(data.length > 0){
            data = data[0]
        }
        let telkikTableProcessamento = (
            <TlkTable
                notGroup={true}
                noDownloadButton={true}
                pageable={false}
                date={new Date()}
                notAction={true}
                viewFor="RotulosNDPHistoricoRotulos"
                forRutoloDetail={true}
                noFilterShow={true}
                modulename="RotulosNDPHistoricoRotulos"
                deleteFunc={(id) => this.handleDelete(id)}
                list={data}
                columnlist={columnlistProcessamento}
                ActionPerform={(action, id) =>
                    this.ActionPerform(action, id)
                }
            />
        );

        this.setState({ telkikTableProcessamento });

    }

    createTableRegisto = async (type, data) => {

        const columnlistRegisto = Object.keys(tablesjson.RotulosNDResumoRegisto.columnkeyMap).map(function (key) {
            return { field: tablesjson.RotulosNDResumoRegisto.columnkeyMap[key], columnMenuType: "checkbox" };
        });

        console.log("columnlist", columnlistRegisto);
        console.log("data", data);

        let telkikTableRegisto = (
            <TlkTable
                notGroup={true}
                noDownloadButton={true}
                pageable={false}
                date={new Date()}
                notAction={true}
                viewFor="RotulosNDResumoRegisto"
                forRutoloDetail={true}
                noFilterShow={true}
                modulename="RotulosNDResumoRegisto"
                deleteFunc={(id) => this.handleDelete(id)}
                list={data}
                columnlist={columnlistRegisto}
                ActionPerform={(action, id) =>
                    this.ActionPerform(action, id)
                }
            />
        );

        this.setState({ telkikTableRegisto });

    }

    formatTableData = (data) => {
        console.log("formatTableData: ", data)
        return data.map((_row, index) => {
            Object.keys(_row).map(function (key) {
                if (key === "indiceCalorico") {
                    Object.keys(_row[key]).map((_k) => {
                        _row[Lang.langCheck.langRequest(_k)] = _row[key][_k];
                    });
                } else {
                    _row[Lang.langCheck.langRequest(key)] = _row[key];
                }
            });
        });
    };

    returntoFirst = async (obs) => {
        let data = {
            VoltarDoSegundo: true,
            Nprocesso: +this.state.parsed.id,
            Ultimaobservacao: obs,
            NumeroAvaliacao: 2,
            processmentos: {
                Pmentos: [],
            },
        };

        let res = await services.apiCall.requestApi(
            "/SIVDP/evelution_approvel_next_lavel",
            data,
            "post"
        );
        if (res) {
            $("#popup-return").trigger("click");
            let paramoption = {
                name: "1ª avaliação",
                url: "rotulos",
                tableName: "RotulosOneAvalicao",
            };
            this.props.history.push({
                pathname: "/rotulos",
                state: { paramoption: paramoption },
            });
        }
    };

    handleLibertar = async () => {
        let res = await services.apiCall.requestApi(
            "/SIVDP/libertar",
            { id: +this.state.parsed.id },
            "post"
        );

        if (res) {
            let paramoption = {
                name: "Pendentes",
                url: "rotulos",
                tableName: "RotulosPendentes",
            };
            this.props.history.push({
                pathname: "/rotulos",
                state: { paramoption: paramoption },
            });
        }
    };

    handleChange = (e, type) => {
        console.log("eleeee", e.target.value);
        let sendData = { ...this.state.sendData };
        console.log("frase", frase)

        if (type === "processoLabel") {
            sendData["processo"] = { ...sendData.processo };
            sendData["processo"][e.target.name] = e.target.checked;
        } else {
            // sendData['processomento'] = {...sendData.processomento}
            sendData[e.target.name] =
                type === "date"
                    ? services.Converter.dateConvert(e.target.value, dateFormat)
                    : e.target.value;
        }

        this.setState({ sendData });
    };

   
    handleTipo = (event) => {
        const selectedSizesText = event.target.value.map(item => item.value).join(", ");
        
        this.setState(prevState => ({
            selectedSizes: event.target.value, // Atualiza os tamanhos selecionados no estado
            Ultimaobservacao: prevState.Ultimaobservacao + (prevState.Ultimaobservacao ? ", " : "") + selectedSizesText // Adiciona os itens selecionados ao valor do textarea, separando-os por vírgula
        }));
    };

    handleChangeTextarea = (e) => {
        this.setState({
            Ultimaobservacao: e.target.value // Atualiza o valor do textarea no estado
        });
    };

    // handleTipo = (event) => {
        
    //     var tipo = event.value.text
    //     var tipoSplit = tipo.split("-")[1]
        
    //     textoTipo = tipoSplit

    // };
    HandleChangeResponsavel = async () => {
        console.log("daaaaatttaaa")
        if($("#RespAnalise :selected").val() != undefined && $("#RespAnalise :selected").val() != "0" && $("#RespAnalise :selected").val() != ""){
            let data = {
                IDRotulo: parseInt(this.state.resData.idRotulo),
                IDUserResponsavel: parseInt($("#RespAnalise :selected").val()),
            };
            let res = await services.apiCall.requestApi(
                "/Rotulos/SubmeterResponsavel",
                data,
                "post"
            );
            if (res) {
                Swal.fire({
                    text: "Responsável alterado com sucesso.",
                    icon: "success"
                  });
            }
        }
        
    }

    handleTipoButton = () => {
        //var tipo = $("#tipoReprov :selected").text();
        var tipoObser = $("#Ultimaobservacao").val();
        $("#Ultimaobservacao").val(tipoObser + textoTipo);
        $("#Ultimaobservacao").text(tipoObser + textoTipo);
    };

    handleFilterChange = (event) => {
        const filter = event.filter.value.toLowerCase();
        const filteredSizes = sizes.filter(size =>
            size.text.toLowerCase().includes(filter)
        );
        this.setState({ filteredSizes });
    };

    render() {
        
        // console.log("data",this.state.sendData, this.state.resData)
        console.log("submetidopor:");
        console.log(this.state);
        let leftNavFields = !(
            this.state.parsed.evaluator || this.state.parsed.view === "processo"
        )
            ? {
                Resumo_de_registo_de_origem: [],
                Resumo_de_registo_de_destino: [],
                ...InputFieldsAll,
            }
            : this.state.estado === "Sob Análise"
                ? {
                    Resumo_de_registo: [],
                    Imagens: [],
                }
                : { Resumo_de_registo: [], ...InputFieldsAll };

        let processmentoLabel = this.state.resData.processmentos || {};
        let processoLabel =
            (this.state.resData && this.state.resData.processo) || {};
        console.log(processoLabel);
        return (
            <div className="dashboard">
                <FormnavBar
                    showReturnButton={
                        this.state.resData.codEstadoRotulo === 4 || this.state.resData.codEstadoRotulo === 5
                    }
                    pendingCases={
                        this.state.resData.evaluationStatus ===
                        "review2_pending" ||
                        this.state.resData.evaluationStatus ===
                        "under_review2" ||
                        this.state.resData.evaluationStatus === "under_review1"
                    }
                    handleLibertar={() => this.handleLibertar()}
                    handleSave={() => this.handleSave()}
                    to={this.state.parsed.from === "agenda_digital" ? "/agenda_digital" : "/rotulos"}
                    handleSubmit={(data, url) => this.handleSubmit(data, url)}
                    returntoFirst={(data) => this.returntoFirst(data)}
                    estado={this.state.resData.estado}
                    numeroAvaliacao={this.state.resData.numeroAvaliacao}
                    parsed={this.state.parsed}
                    type="parcelas"
                    headName={this.state.headName}
                    evaluator={
                        this.state.resData.evaluationStatus ===
                        "review2_pending" ||
                        this.state.resData.evaluationStatus ===
                        "under_review2" ||
                        this.state.resData.evaluationStatus === "under_review1"
                    }
                />
                <div className="full-container edit-ward">
                    <FormleftNev
                        InputFieldsAll={leftNavFields}
                        navFor="Rotulo"
                    />
                    <div className="right-section right-section-processo">
                        <div className="row top-serch">
                            {Object.keys(this.state.parsed).length > 0 &&
                                this.state.parsed.evaluator > 0 && (
                                    <div className="col-md-12 rotuloMessageMainDiv">
                                        <div className="rotuloMessageChildDiv">
                                            <span
                                                style={{
                                                    marginTop: "3px",
                                                    marginRight: "10px",
                                                }}
                                                className="k-icon k-i-information"
                                            />
                                            <p>
                                                {this.state.parsed.evaluator ==
                                                    1 &&
                                                    (this.state.resData &&
                                                        this.state.resData
                                                            .evaluationStatus ===
                                                        "review1_pending_2" ? (
                                                        <>
                                                            Este processo foi
                                                            retornado da 2ª
                                                            avaliação :{" "}
                                                            {
                                                                this.state
                                                                    .resData
                                                                    .outrosObsercao
                                                            }{" "}
                                                            <br />
                                                            {/* {`Observação do avaliador: ${this.state.resData.outrosObsercao}`} */}
                                                        </>
                                                    ) : this.state.parsed
                                                        .estado ===
                                                        "Sob Análise" ? (
                                                        `Em análise por: ${this.state.resData.submetidopor} `
                                                    ) : (
                                                        "Este processo encontra-se em realização da 1ª avaliação"
                                                    ))}
                                                {this.state.parsed.evaluator ==
                                                    2 &&
                                                    "Este processo encontra-se em realização da 2ª avaliação"}
                                            </p>
                                        </div>
                                    </div>
                                )}
                            {this.state.parsed.evaluator ||
                             
                                this.state.parsed.view === "processo" ? (
                                    <>
                                    
                                <div
                                    className="bg-white middle p20"
                                    id="Resumo_de_registo"
                                >
                                    <div className="head">
                                        <h2>
                                            {Lang.langCheck.langRequest(
                                                "Resumo da Certificação"
                                            )}
                                        </h2>
                                        <br></br>
                                        <p>Responsável pela análise</p>
                                        <div className={"row"}>
                                            <div className={"col-md-3"}>
                                            <select className="custome-drop-down" name="RespAnalise" id="RespAnalise" >
                                                <option value="">Selecione...</option> 
                                            </select>
                                            </div>
                                            <div className={"col-md-3"}>
                                                <button onClick={this.HandleChangeResponsavel} style={{backgroundColor: "#960030" , color:"white" , borderRadius: "4px" , border: "1px solid #960030" , padding: "4px 5px 4px 5px>"}}>Assumir tarefa</button>
                                            </div>
                                        </div>
                                        <br></br>
                                        <p className="font-14"></p>

                                        {this.state.telkikTableRegisto}

                                        {/* {this.state.telkikTable} */}
                                        
                                    </div>
                                    {/*MOVIDA TABELA PARA O FINAL DA PÁGINA - PEDIDO PELO CLIENTE A 26-11-2021*/}
                                    {/*<div className="head">*/}
                                    {/*    <h2>*/}
                                    {/*        Rótulos aprovados para o registo*/}
                                    {/*    </h2>*/}
                                    {/*    <p className="font-14"></p>*/}
                                    {/*    <LabelTabel id={this.state.parsed.id} />*/}
                                    {/*</div>*/}
                                </div>
                                    </>
                                    
                            ) : (
                                <>
                                    <div
                                        className="bg-white middle p20"
                                        id="Resumo_de_registo_de_origem"
                                    >
                                        <div className="head mb-4">
                                            <h2>
                                                {Lang.langCheck.langRequest(
                                                    "Resumo da Certificação de origem"
                                                )}
                                            </h2>
                                            <p className="font-14"></p>
                                        </div>
                                        <div>
                                            <TlkTable
                                                notGroup={true}
                                                noDownloadButton={true}
                                                pageable={false}
                                                date={new Date()}
                                                collepsview={true}
                                                notAction={true}
                                                viewFor={"rotulos"}
                                                noFilterShow={true}
                                                forRutoloDetail={true}
                                                modulename={"rotulos"}
                                                deleteFunc={(id) =>
                                                    this.handleDelete(id)
                                                }
                                                list={
                                                    this.state.resData
                                                        .resumo_do_registo_deorigem
                                                }
                                                columnlist={this.columnlist}
                                                ActionPerform={(action, id) =>
                                                    this.ActionPerform(
                                                        action,
                                                        id
                                                    )
                                                }
                                            />
                                        </div>
                                    </div>
                                    <div
                                        className="bg-white middle p20"
                                        id="Resumo_de_registo_de_destino"
                                    >
                                        <div className="head mb-4">
                                            <h2>
                                                {Lang.langCheck.langRequest(
                                                    "Resumo da Certificação de destino"
                                                )}
                                            </h2>
                                        </div>
                                        <div>
                                            <TlkTable
                                                notGroup={true}
                                                noDownloadButton={true}
                                                pageable={false}
                                                date={new Date()}
                                                collepsview={true}
                                                notAction={true}
                                                noFilterShow={true}
                                                forRutoloDetail={true}
                                                viewFor={"rotulos"}
                                                modulename={"rotulos"}
                                                deleteFunc={(id) =>
                                                    this.handleDelete(id)
                                                }
                                                list={
                                                    this.state.resData
                                                        .resumo_do_registo_destino
                                                }
                                                columnlist={this.columnlist}
                                                ActionPerform={(action, id) =>
                                                    this.ActionPerform(
                                                        action,
                                                        id
                                                    )
                                                }
                                            />
                                        </div>
                                    </div>
                                </>
                            )}
                            <div
                                className="bg-white middle p20"
                                id="Charatiristicas_do_Rotulo"
                            >
                                <div className="head mb-4">
                                    <h2>
                                        {Lang.langCheck.langRequest(
                                            "Charatiristicas_do_Rotulo"
                                        )}
                                    </h2>
                                </div>
                                <div className={"row"}>
                                    <div className={"col-md-3"}>
                                        <p className="rotulos_head m-0">
                                            <label
                                                style={{ "margin-bottom": 0 }}
                                            >
                                                Marca
                                            </label>
                                        </p>
                                        <p>
                                            {" "}
                                            <label className="rotulos_content">
                                                {this.state.resData.marca || "nd"}
                                            </label>
                                        </p>
                                    </div>
                                    <div className={"col-md-3"}>
                                        <p className="rotulos_head m-0">
                                            <label
                                                style={{ "margin-bottom": 0 }}
                                            >
                                                País
                                            </label>
                                        </p>
                                        <p>
                                            {" "}
                                            <label className="rotulos_content">
                                                {this.state.resData.pais || "nd"}
                                            </label>
                                        </p>
                                    </div>
                                </div>
                                <div className={"row"}>
                                    <div className={"col-md-3"}>
                                        <label className="rotulos_head mb-0">
                                            Ano
                                        </label>
                                        <br />
                                        <label className="rotulos_content">
                                            {this.state.resData.anoProduto}
                                        </label>
                                    </div>
                                    <div className={"col-md-3"}>
                                        <label className="rotulos_head mb-0">
                                            Cor
                                        </label>
                                        <br />
                                        <label className="rotulos_content">
                                            {this.state.resData.cor}
                                        </label>
                                    </div>
                                    <div className={"col-md-3"}>
                                        <label className="rotulos_head mb-0">
                                            Bag in box
                                        </label>
                                        <br />
                                        <label className="rotulos_content">
                                            {this.state.resData.bagInBox == true ?  sim : nao}
                                        </label>
                                    </div>
                                    <div className={"col-md-3"}>
                                        <label className="rotulos_head mb-0">
                                            Capacidade a apresentar no rótulo
                                        </label>
                                        <br />
                                        <label className="rotulos_content">
                                            {this.state.resData.capacidadeIndicada}
                                        </label>
                                    </div>
                                    <div className={"col-md-3 mt-0 mt-md-4"}>
                                        <label className="rotulos_head mb-0">
                                            Teor alcoólico
                                        </label>
                                        <br />
                                        <label className="rotulos_content">
                                            {this.state.resData.tav} %
                                        </label>
                                    </div>
                                    <div className={"col-md-3 mt-0 mt-md-4"}>
                                        <label className="rotulos_head mb-0">
                                            Logo Wines of Portugal
                                        </label>
                                        <br />
                                        <label className="rotulos_content">
                                            {this.state.resData.logoWP == true ?  sim : nao}
                                        </label>
                                    </div>
                                    <div className={"col-md-3 mt-0 mt-md-4"}>
                                        <label className="rotulos_head mb-0">
                                            Selo Incorporado
                                        </label>
                                        <br />
                                        <label className="rotulos_content">
                                            {this.state.resData.seloIncorporado == true ?  sim : nao}
                                        </label>
                                    </div>
                                    <div className={"col-md-3 mt-0 mt-md-4"}>
                                        <label className="rotulos_head mb-0">
                                            Menção facultativa
                                        </label>
                                        <br />
                                        <label className="rotulos_content">
                                            {this.state.resData.mencaoFacultativa}
                                        </label>
                                    </div>
                                    <div className={"col-md-6 mt-0 mt-md-4"}>
                                        <label className="rotulos_head mb-0">
                                            Entidade
                                        </label>
                                        <br />
                                        <label className="rotulos_content">
                                            {this.state.resData.entidade}
                                        </label>
                                    </div>
                                    <div className={"col-md-6 mt-0 mt-md-4"}>
                                        <label className="rotulos_head mb-0">
                                            Morada da Entidade
                                        </label>
                                        <br />
                                        <label className="rotulos_content">
                                            {this.state.resData.moradaEntidade + " , " + this.state.resData.codigoPostal + " , " + this.state.resData.localidade }
                                        </label>
                                    </div>
                                    <div
                                        className={
                                            "col-md-6  mt-0 mt-md-4 custom-documentation"
                                        }
                                    >
                                        {/* <Button
                                            className={
                                                "k-button k-primary btn-sm"
                                            }
                                            onClick={() =>
                                                this.createPDF("document")
                                            }
                                        >
                                            <span
                                                class="k-icon k-i-attachment"
                                                style={{
                                                    transform: "rotate(90deg)",
                                                    marginRight: "5px",
                                                }}
                                            />{" "}
                                            Documento de cedência de marca
                                        </Button> */}
                                    </div>
                                </div>
                            </div>
                            {/* <div
                                className="bg-white middle p20"
                                id="Dados_do_Processo"
                            >
                                <div className="head mb-4">
                                    <h2>
                                        {Lang.langCheck.langRequest("Processo")}{" "}
                                    </h2>
                                </div>
                                <p className="font-14"></p>
                                <div className={"row"}>
                                    <div className={"col-md-6"}>
                                        <label className="rotulos_head mb-0">
                                            Submetido por
                                        </label>
                                        <br />
                                        <label className="rotulos_content">
                                            {processoLabel.submetidopor || "nd"}
                                        </label>
                                    </div>
                                    <div className={"col-md-6"}>
                                        <label className="rotulos_head mb-0">
                                            Data de submissão do pedido
                                        </label>
                                        <br />
                                        <label className="rotulos_content">
                                            {moment(
                                                processoLabel.datadesubmisso
                                            ).format(dateFormat)}
                                        </label>
                                    </div>
                                </div>
                                <div className={"row mt-4 preceso-check "}>
                                    <div
                                        className={
                                            "col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12"
                                        }
                                    >
                                        <div className="custom-control custom-checkbox">
                                            <Input
                                                disabled
                                                readOnly
                                                type="checkbox"
                                                checked={
                                                    this.state.sendData
                                                        .processo[
                                                    "seloIncorporado"
                                                    ]
                                                }
                                                name="seloIncorporado"
                                                onChange={(e) =>
                                                    this.handleChange(
                                                        e,
                                                        "processoLabel"
                                                    )
                                                }
                                                className="custom-control-input border-0 w-auto"
                                                id="customCheck1"
                                            />
                                            <label
                                                class="custom-control-label"
                                                for="customCheck1"
                                            >
                                                Selo incorporado
                                            </label>
                                        </div>
                                    </div>

                                    <div
                                        className={
                                            "col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12"
                                        }
                                    >
                                        <div className="custom-control custom-checkbox">
                                            <Input
                                                disabled
                                                readOnly
                                                type="checkbox"
                                                checked={
                                                    this.state.sendData
                                                        .processo[
                                                    "macrapropria"
                                                    ]
                                                }
                                                name="macrapropria"
                                                onChange={(e) =>
                                                    this.handleChange(
                                                        e,
                                                        "processoLabel"
                                                    )
                                                }
                                                className="custom-control-input border-0 w-auto"
                                                id="customCheck2"
                                            />
                                            <label
                                                class="custom-control-label"
                                                for="customCheck2"
                                            >
                                                Marca Própria
                                            </label>
                                        </div>
                                    </div>

                                    <div
                                        className={
                                            "col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12"
                                        }
                                    >
                                        <div className="custom-control custom-checkbox">
                                            <Input
                                                disabled
                                                readOnly
                                                type="checkbox"
                                                checked={
                                                    this.state.sendData
                                                        .processo["logo"]
                                                }
                                                name="logo"
                                                onChange={(e) =>
                                                    this.handleChange(
                                                        e,
                                                        "processoLabel"
                                                    )
                                                }
                                                className="custom-control-input border-0 w-auto"
                                                id="customCheck3"
                                            />
                                            <label
                                                class="custom-control-label"
                                                for="customCheck3"
                                            >
                                                Logo wines of portugal
                                            </label>
                                        </div>
                                    </div>

                                    <div
                                        className={
                                            "col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12"
                                        }
                                    >
                                        <div className="custom-control custom-checkbox">
                                            <Input
                                                disabled
                                                readOnly
                                                type="checkbox"
                                                checked={
                                                    this.state.sendData
                                                        .processo["bib"] ||
                                                    false
                                                }
                                                name="bib"
                                                onChange={(e) =>
                                                    this.handleChange(
                                                        e,
                                                        "processoLabel"
                                                    )
                                                }
                                                className="custom-control-input border-0 w-auto"
                                                id="customCheck4"
                                            />
                                            <label
                                                class="custom-control-label"
                                                for="customCheck4"
                                            >
                                                Bag in Box(BiB)
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div className={"row"}>
                                    <div className={"col-md-6"}>
                                        <label className="rotulos_head mb-0">
                                            Email de notificação
                                        </label>
                                        <br />
                                        <label className="rotulos_content">
                                            {processoLabel.emaildenotificao}
                                        </label>
                                    </div>
                                    <div className={"col-md-6"}>
                                        <label className="rotulos_head mb-0">
                                            {this.state.parsed.evaluator == 0
                                                ? "Mercado / País"
                                                : "Mercado especifico"}
                                        </label>
                                        <br />
                                        <label className="rotulos_content">
                                            {processoLabel.mercadoEspecificoNome ||
                                                "nd"}
                                        </label>
                                    </div>
                                </div>
                            </div> */}
                            <div className="bg-white middle p20" id="Imagens">
                                <div className="head mb-4">
                                    <h2>
                                        {Lang.langCheck.langRequest("Imagens")}
                                    </h2>
                                    <p className="font-14"></p>
                                </div>
                                <div className={"row pt-0 pb-2"}>
                                    {/* <div className={"col-md-6"}>
                                            <Carousel showArrows={true}>
                                                {
                                                    this.state.resData && this.state.resData.imagens && this.state.resData.imagens.map((_img,i)=>(
                                                        <div key={i}>
                                                            <img src={imageObj} />
                                                        </div>
                                                    ))
                                                }
                                            </Carousel>
                                        </div> */}
                                    <div className={"col-md-6"}>
                                        <label>Anexos do Rótulo</label>
                                        <div id="anexosBox"></div>
                                    </div>
                                    <div className={"col-md-6"}>
                                    <label>Outros Anexos do Rótulo</label>
                                        <div id="anexosBox1"></div>
                                        {/* <label style={{"margin-bottom": 0}}>Outros formatos (ex.: PDFs)</label><br/>
                                            <a onClick={()=>this.createPDF('Outros Formatos')}>dummy_file_dot_pdf</a> */}
                                        {/* {(this.state.imagens && !!this.state.imagens.length) && this.state.imagens.map((item, index) => (
                                            <><a href={item.url} target="_blank">{item.nomeFicheiro}</a><br></br></>
                                        ))} */}
                                        
                                        {/* <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th scope="col">
                                                        Imagens anexadas
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        <a
                                                            onClick={() =>
                                                                this.createPDF(
                                                                    "Outros Formatos"
                                                                )
                                                            }
                                                            className="ml-3"
                                                        >
                                                            dummy_file_dot_pdf
                                                        </a>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table> */}
                                    </div>
                                </div>
                            </div>
                            {this.state.estado === "Sob Análise" ? (
                                ""
                            ) : (
                                <div
                                    className="bg-white middle p20 position-relative"
                                    id="Processa_mento"
                                >
                                    {/* {!this.state.parsed.view && (
                                        <Tooltip
                                            title="Inserir notas justificativas sobre processamento"
                                            color={"#333"}
                                        >
                                            <span
                                                data-toggle="modal"
                                                data-target="#left-popup-center"
                                                onClick={() =>
                                                    this.setState({
                                                        show: true,
                                                    })
                                                }
                                                className="add-plus cursor-pointer"
                                            >
                                                <i className="fas fa-plus"></i>
                                            </span>
                                        </Tooltip>
                                    )} */}
                                    <div className="head position-relative mb-4">
                                        <h2>
                                            {Lang.langCheck.langRequest(
                                                "Processamento"
                                            )}
                                        </h2>
                                        <p className="font-14"></p>

                                        {this.state.telkikTableProcessamento}

                                        {/* {this.state.mandatoryMissing &&
                                            !this.state.isRemarkSet &&
                                            this.state.nullProcess && (
                                                <span
                                                    className="text-danger"
                                                    style={{
                                                        marginTop: "-10px",
                                                    }}
                                                >
                                                    Campo obrigatório
                                                </span>
                                            )} */}
                                    </div>
                                    {this.state.resData.codEstadoRotulo === 2 || this.state.resData.codEstadoRotulo === 6 ? (
                                        
                                        <>
                                            <div className="pd20">
                                                <div className="row mt-3">
                                                {/* <div className="head position-relative mb-4">
                                                    <h2>
                                                        {Lang.langCheck.langRequest(
                                                            "Processamento"
                                                        )}
                                                    </h2>
                                                    <p className="font-14"></p>

                                                    {this.state.telkikTableProcessamento}

                                                </div> */}
                                                    {/* <div className="col-md-4">
                                                        <label class="rotulos_head mb-0">
                                                            Classificação
                                                        </label>
                                                        <br />
                                                        <label className="rotulos_content">
                                                            {this.state.resData.estado}
                                                        </label>
                                                    </div> */}
                                                    {/* <div className= "col-lg-6 col-md-2 col-sm-12 input-style-float">
                                                    <div div className="input-box active-grey">
                                                            <label class="z-index-9">
                                                                Frases Personalizadas
                                                            </label>
                                                        <select className="custome-drop-down" name="tipoReprov" id="tipoReprov" >
                                                        <option value="">Selecione...</option> 
                                                    </select>
                                                    </div>
                                                </div> */}
                                                {/*                                                     
                                                    <div className="col-md-8">

                                                        <label class="rotulos_head mb-0">
                                                        Fundamento da decisão
                                                        </label>
                                                        <br />
                                                        <label className="rotulos_content">
                                                            {this.state.resData
                                                                .observacoesAvaliacao ||
                                                                "N/A"}
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="pd20">
                                                <div className="row mt-3">
                                                    <div className="col-md-4">
                                                        <label class="rotulos_head mb-0">
                                                            Submetido por
                                                        </label>
                                                        <br />
                                                        <label className="rotulos_content">
                                                            {
                                                                this.state
                                                                    .resData
                                                                    .criadoPor
                                                            }
                                                        </label>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <label class="rotulos_head mb-0">
                                                            Data de submissão de
                                                            pedido
                                                        </label>
                                                        <br />
                                                        <label className="rotulos_content">
                                                            {moment(
                                                                this.state
                                                                    .resData
                                                                    .dataCriado
                                                            ).format(
                                                                dateFormat
                                                            )}
                                                        </label>
                                                    </div>
                                                    
                                                </div>
                                                <div className="row mt-3">
                                                    <div className="col-md-4">
                                                        <label class="rotulos_head mb-0">
                                                            Avaliado Por
                                                        </label>
                                                        <br />
                                                        <label className="rotulos_content">
                                                            {this.state.resData.avaliadoPor}
                                                        </label>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <label class="rotulos_head mb-0">
                                                            Data de avaliação
                                                        </label>
                                                        <br />
                                                        <label className="rotulos_content">
                                                            {this.state
                                                                    .resData
                                                                    .dataAvaliacao ?
                                                            moment(
                                                                this.state
                                                                    .resData
                                                                    .dataAvaliacao
                                                            ).format(
                                                                dateFormat
                                                            ) : "N/A"}
                                                        </label>
                                                    </div> */}
                                                    {/* <div className="col-md-3">
                                                        <label class="rotulos_head mb-0">
                                                            Data de 2ª avaliação
                                                        </label>
                                                        <br />
                                                        <label className="rotulos_content">
                                                            {moment(
                                                                this.state
                                                                    .resData
                                                                    .datade2availicao ||
                                                                new Date()
                                                            ).format(
                                                                dateFormat
                                                            )}
                                                        </label>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <label class="rotulos_head mb-0">
                                                            Data de finalização
                                                        </label>
                                                        <br />
                                                        <label className="rotulos_content">
                                                            {moment(
                                                                this.state
                                                                    .resData
                                                                    .datadefinalizaco ||
                                                                new Date()
                                                            ).format(
                                                                dateFormat
                                                            )}
                                                        </label>
                                                    </div> */}
                                                    
                                                </div>
                                            </div>
                                        </>
                                    ) : this.state.resData.codEstadoRotulo === 4 || this.state.resData.codEstadoRotulo === 5 ? (
                                        // console.log("hello world",this.state.parsed )
                                        
                                        <>
                                        
                                            <div className="pd20">
                                                {/* <div className="row mt-3">
                                                    <div className="col-md-6">
                                                        <label class="rotulos_head mb-0">
                                                            Data 1º avaliação
                                                        </label>
                                                        <br />
                                                        <label className="rotulos_content">
                                                            {moment(
                                                                processmentoLabel.dataOneEvolution ||
                                                                new Date()
                                                            ).format(
                                                                dateFormat
                                                            )}
                                                        </label>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <label class="rotulos_head mb-0">
                                                            Estado
                                                        </label>
                                                        <br />
                                                        <label className="rotulos_content">
                                                            {Lang.langCheck.langRequest(
                                                                this.state
                                                                    .resData
                                                                    .evaluation1Decision
                                                            ) || "nd"}
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="row mt-3">
                                                    <div className="col-md-12">
                                                        <label class="rotulos_head mb-0">
                                                            Observações
                                                        </label>
                                                        <br />
                                                        <label className="rotulos_content">
                                                            {processmentoLabel.observacao ||
                                                                "nd"}
                                                        </label>
                                                    </div>
                                                </div> */}
                                            </div>
                                            
                                                {/* <div className="row mt-3">
                                                <div className="col-md-4">
                                                    <label class="rotulos_head mb-0">
                                                        Submetido por
                                                    </label>
                                                    <br />
                                                    <label className="rotulos_content">
                                                        {
                                                            this.state
                                                                .resData
                                                                .criadoPor
                                                        }
                                                    </label>
                                                </div>
                                                <div className="col-md-4">
                                                    <label class="rotulos_head mb-0">
                                                        Data de submissão de
                                                        pedido
                                                    </label>
                                                    <br />
                                                    <label className="rotulos_content">
                                                        {moment(
                                                            this.state
                                                                .resData
                                                                .dataCriado
                                                        ).format(
                                                            dateFormat
                                                        )}
                                                    </label>
                                                </div>
                                                
                                            </div> */}
                                            {/* <div className="row mt-3">
                                                
                                                {this.state.resData.codEstadoRotulo === 5 &&
                                                <>
                                                <div className="col-md-4">
                                                    <label class="rotulos_head mb-0">
                                                        Avaliado Por
                                                    </label>
                                                    <br />
                                                    <label className="rotulos_content">
                                                        {this.state.resData.avaliadoPor}
                                                    </label>
                                                </div>
                                                <div className="col-md-4">
                                                    <label class="rotulos_head mb-0">
                                                        Data de avaliação
                                                    </label>
                                                    <br />
                                                    <label className="rotulos_content">
                                                        {this.state
                                                                .resData
                                                                .dataAvaliacao ?
                                                        moment(
                                                            this.state
                                                                .resData
                                                                .dataAvaliacao
                                                        ).format(
                                                            dateFormat
                                                        ) : "N/A"}
                                                    </label>
                                                </div>
                                               
                                                <div className="col-md-4">
                                                    <label class="rotulos_head mb-0">
                                                    Fundamento da decisão
                                                    </label>
                                                    <br />
                                                    <label className="rotulos_content">
                                                        {this.state.resData
                                                            .observacoesAvaliacao ||
                                                            "N/A"}
                                                    </label>
                                                </div>
                                                </>}
                                            </div>
                                             */}
                                                
                                            <div
                                                className={
                                                    "row align-items-center"
                                                }
                                            >
                                                
                                                <div className="{col-md-12}">
                                                    <div className="input-box active-grey mt20">
                                                        <div className="ml-4">
                                                            Aprovar rótulo?
                                                        </div>
                                                        <Switch
                                                            disabled={disableSubmit}
                                                            id="switch1"
                                                            name="aprovodo"
                                                            className="ml-4"
                                                            onLabel=""
                                                            offLabel=""
                                                            checked={
                                                                this.state
                                                                    .sendData
                                                                    .aprovodo
                                                            }
                                                            style={{
                                                                width: "100%",
                                                            }}
                                                            onChange={(e) =>
                                                                this.handleChange(
                                                                    e,
                                                                    "toggle"
                                                                )
                                                            }
                                                        />
                                                        <label class="z-index-9 pl-4">
                                                            {" "}
                                                            <span className="circle-green"></span>
                                                            Sim /{" "}
                                                            <span className="circle-red"></span>
                                                            Não
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className={"row"}>
                                                {/* <div className="col-lg-2 col-md-2 col-sm-12 input-style-float"> */}
                                                <div className= "col-lg-10 col-md-10 col-sm-12 input-style-float">
                                                    <label className="z-index-9">
                                                            Frases Personalizadas
                                                            </label>
                                                            <div className="d-flex">
                                                           <MultiSelect
                                                                data={this.state.filteredSizes != null ? this.state.filteredSizes : sizes}
                                                                onChange={this.handleTipo}
                                                                textField="text"
                                                                dataItemKey="value"
                                                                id="tipoReprov"
                                                                value={this.state.selectedSizes} // Define os tamanhos selecionados
                                                                style={{ width: "100%" }}
                                                                placeholder="Selecione uma frase para adicionar em baixo"
                                                                filterable={true} // Habilita a funcionalidade de pesquisa
                                                                onFilterChange={this.handleFilterChange} // Evento para controlar o filtro
                                                            />
                                
                                                            {/* <DropDownList
                                                                disabled={disableSubmit}
                                                                data={sizes}
                                                                onChange={this.handleTipo}
                                                                textField="text"
                                                                dataItemKey="value"
                                                                id="tipoReprov"
                                                                defaultItem={defaultItem}
                                                                style={{
                                                                width: "100%",
                                                                }}
                                                            />   */}
                                                      {/* <button disabled={disableSubmit} id="adicionarButton" style={{marginLeft: "5px" , backgroundColor:" #960030" ,color: "white" ,border: "none", borderRadius: "4px"}}  onClick={this.handleTipoButton}>Adicionar</button> */}
                                                            </div>
                                                   
                                               
                                                
                                                </div>
                                                {/* </div> */}
                                                <div className={"col-md-12"}>
                                                    <div className="input-box active-grey mt20">
                                                        <label className="z-index-9">
                                                        Fundamento da decisão
                                                        </label>
                                                        <textarea
                                                            name="Ultimaobservacao"
                                                            id="Ultimaobservacao"
                                                            rows="6"
                                                            value={this.state.Ultimaobservacao}
                                                            onChange={this.handleChangeTextarea}
                                                            className={"form-control heigh-auto"}
                                                        ></textarea>
                                                        {/* {this.state
                                                            .mandatoryMissing &&
                                                            !this.state.sendData
                                                                .Ultimaobservacao && (
                                                                <span
                                                                    className="text-danger"
                                                                    style={{
                                                                        marginTop:
                                                                            "-10px",
                                                                    }}
                                                                >
                                                                    Campo
                                                                    obrigatório
                                                                </span>
                                                            )} */}
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    ) : (<></>)}
                                </div>
                            )}
                            
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default RotulosNDProcesso;
